// src/services/p2pWebSocketService.js
import * as SockJS from "sockjs-client";
import * as Stomp from "stompjs";

class P2PWebSocketService {
  constructor() {
    this.stompClient = null;
    this.connected = false;
    this.subscription = null;
    this.messageCallback = null;
  }

  connect() {
    return new Promise((resolve, reject) => {
      const socket = new SockJS("https://api.paybito.com:9443/p2pservice/ws"); // Replace with your actual URL
      this.stompClient = Stomp.over(socket);
      this.stompClient.debug = () => {}; // Optional: silence debug logs

      this.stompClient.connect({}, () => {
        this.connected = true;
        console.log("✅ WebSocket connected");
        resolve();
      }, (error) => {
        console.error("❌ WebSocket connection error:", error);
        reject(error);
      });
    });
  }

  subscribeToP2P() {
    try{
if (!this.connected || !this.stompClient) {
      console.warn("WebSocket not connected.");
      return;
    }

    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    this.subscription = this.stompClient.subscribe("/user/topic/ad", (msg) => {
      if (this.messageCallback) {
        this.messageCallback(msg.body);
      }
    });
    }
    catch{

    }
    
  }

  subscribe(adType, crypto, availableAmount, paymentMethod, dataOrder, region, baseCurrency, offset, limit) {
    const req = {
      uuid: localStorage.getItem("uuid"),
      adType,
      crypto,
      availableAmount,
      paymentMethod,
      dataOrder,
      region,
      baseCurrency,
      offset,
      limit,
    };
    try{
    this._send("/app/adRequest", req); // Replace "/app/p2p" with the actual send endpoint if different

    }
    catch{

    }

  }

  _send(destination, body) {
    if (this.connected && this.stompClient) {
      this.stompClient.send(destination, {}, JSON.stringify(body));
    } else {
      console.warn("Cannot send. WebSocket not connected.");
    }
  }

  onMessage(callback) {
    this.messageCallback = callback;
  }

  disconnect() {
    try{
if (this.stompClient && this.connected) {
      this.stompClient.disconnect(() => {
        console.log("🔌 WebSocket disconnected");
        this.connected = false;
        this.subscription = null;
      });
    }
    }
    catch{

    }
    
  }
}

const p2pWebSocketService = new P2PWebSocketService();
export default p2pWebSocketService;
